import { render, staticRenderFns } from "./TrackingXmlCteIndisponivel.vue?vue&type=template&id=5fc196d2"
import script from "./TrackingXmlCteIndisponivel.vue?vue&type=script&lang=js"
export * from "./TrackingXmlCteIndisponivel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports